<template>
  <div>
    <div>
      <strong class="d-flex justify-center mb-3">
        تعداد :
        {{
          $store.getters.tradeRequestDirectCurrentList &&
          $store.getters.tradeRequestDirectCurrentList.totalCount
            ? $store.getters.tradeRequestDirectCurrentList.totalCount + 'مورد'
            : 'موردی یافت نشد'
        }}
      </strong>

      <v-sheet outlined>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="items"
          tableClasses="item-table border"
          responsive
          hide-default-footer
          disable-pagination
          fixed-header
          ref="baseTable"
          :single-select="true"
          show-select
          v-model="selected"
          checkbox-color="primary"
        >
          <template v-slot:[`item.createdTimeUtc`]="{ item }">
            {{ item.createdTimeUtc | moment }}
          </template>
          <!-- <template v-slot:[`item.request`]="{ item }">
            {{ tradeRequestDisplayName(item.request) }}
          </template> -->
          <!-- <template v-slot:[`item.category`]="{ item }">
            {{ tradeCategoryDisplayName(item.category) }}
          </template> -->
          <template v-slot:[`item.requestStatus`]="{ item }">
           <span v-if="item.tradeResponseForStatDto.length==0">{{ requestStatusDisplayName(item.requestStatus) }} </span> <span style="color:blue;font-weight: 800;" v-if="item.tradeResponseForStatDto.length>0">پیشنهاد قیمت دارد</span>
          </template>
          <template v-slot:[`item.payment`]="{ item }">
            {{ item.paymentCoreId || item.membershipPlanId ? 'بله' : 'خیر' }}
          </template>

          <template v-slot:[`item.operations`]="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item link color="primary" @click="displayItem(item)">
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>مشاهده جزئیات</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="item.requestStatus == 'Draft'"
                  link
                  color="primary"
                  @click="editItem(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-lead-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>ویرایش</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="item.requestStatus == 'Published'"
                  link
                  color="primary"
                  @click="manageResponse(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-file-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>کنترل پیشنهاد</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item
                  v-if="item.requestStatus == 'Published'"
                  link
                  color="primary"
                  @click="displayResponse(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-file-document</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title> مشاهده پاسخ</v-list-item-title>
                  </v-list-item-content>
                </v-list-item> -->
                <v-list-item
                  v-if="
                    item.requestStatus == 'Draft' ||
                    item.requestStatus == 'Rejected'
                  "
                  link
                  color="primary"
                  @click="viewReport(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-send</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <!--
              @click="confirmRequest(item)"

                  <v-list-item-title> ارسال جهت تایید و انتشار</v-list-item-title> -->
                    <v-list-item-title> بررسی جهت ارسال </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item
                  v-if="
                    item.requestStatus == 'Draft' ||
                    item.requestStatus == 'Published' ||
                    item.requestStatus == 'CanceledByRequester'
                  "
                  link
                  color="primary"
                  @click="sendChatWithAdmin(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-message</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title> ارسال پیام به ادمین </v-list-item-title>
                  </v-list-item-content>
                </v-list-item> -->
                <!-- <v-list-item
                  v-if="
                    item.requestStatus == 'Draft' ||
                    item.requestStatus == 'Rejected'
                  "
                  link
                  color="primary"
                  @click="openlimitationEditModal(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      ویرایش محدودیت جغرافیایی
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item> -->
                <!-- <v-list-item
                  v-if="
                    item.requestStatus == 'Draft' ||
                    item.requestStatus == 'Rejected'
                  "
                  link
                  color="primary"
                  @click="openTechInfoEditModal(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title> ویرایش فرآیندها </v-list-item-title>
                  </v-list-item-content>
                </v-list-item> -->
                <v-list-item
                  v-if="
                    item.bidExpirationTimeInDaysFromNow == 0 &&
                    item.requestStatus != 'SuccessClosed'
                  "
                  link
                  color="primary"
                  @click="openDateExtensionModal(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small> mdi-update</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title> تمدید سفارش</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- ----------------------------------------------- -->
          </template>
        </v-data-table>
      </v-sheet>
      <v-dialog
        v-if="EditLimitationModal"
        v-model="EditLimitationModal"
        max-width="700px"
      >
        <v-card class="py-6">
          <v-card-text>
            <v-row>
              <v-col cols="12" v-if="!limitationEditMode">
                <label>محدودیت مکانی : </label>
                <strong>
                  {{
                    selectedLimitation.limitation == null
                      ? 'ندارد'
                      : selectedLimitation.limitation == 'State'
                      ? 'استانی'
                      : selectedLimitation.limitation == 'City'
                      ? 'شهری'
                      : ''
                  }}
                </strong>
                <div v-if="selectedLimitation.limitation == 'State'">
                  <label> لیست استان ها : </label>
                  <strong v-for="state in stateName" :key="state">
                    {{ state }} ،
                  </strong>
                </div>
                <div v-else-if="selectedLimitation.limitation == 'City'">
                  <v-col cols="12">
                    <label> لیست استان ها : </label>
                    <strong v-for="state in stateName" :key="state">
                      {{ state }}،
                    </strong>
                  </v-col>
                  <v-col cols="12">
                    <label> لیست شهرها : </label>
                    <strong v-for="city in cityName" :key="city">
                      {{ city }} ،
                    </strong>
                  </v-col>
                </div>
              </v-col>
              <v-col cols="12" v-else>
                <v-col cols="12">
                  <v-select
                    v-model="limitation"
                    :items="tradeRequestOrigin"
                    item-text="displayName"
                    item-value="title"
                    persistent-hint
                    clearable
                    hide-details
                    dense
                    outlined
                    label="نوع محدودیت"
                  ></v-select>
                </v-col>
                <v-col cols="12" v-if="limitation && limitation.length">
                  <v-autocomplete
                    :items="statesList"
                    multiple
                    dense
                    label="انتخاب استان"
                    small-chips
                    deletable-chips
                    outlined
                    item-text="value"
                    item-value="id"
                    v-model="stateIds"
                    :placeholder="`لیست استان های های مورد نظر خود را انتخاب کنید`"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  v-if="limitation && limitation == 'City'"
                  class="mt-n4"
                >
                  <div dir="rtl">
                    <strong>
                      {{
                        stateIds && stateIds.length
                          ? 'انتخاب شهر'
                          : 'ابتدا استان های مربوطه را انتخاب کنید'
                      }}
                    </strong>
                    <treeselect
                      appendToBody
                      required
                      :flatten-search-results="true"
                      :disable-branch-nodes="true"
                      :show-count="true"
                      :options="citiesList"
                      placeholder="لیست شهرهای های مورد نظر خود را انتخاب کنید"
                      v-model="limitationIds"
                      :normalizer="normalizerCityList"
                      outlined
                      :multiple="true"
                      dense
                      item-text="stateCityName"
                      item-value="id"
                    />
                  </div>
                </v-col>
              </v-col>
              <v-col cols="12" class="text-right float-right">
                <v-btn
                  class="mx-1"
                  small
                  v-if="
                    selectedLimitation.limitation != null && !limitationEditMode
                  "
                  color="error"
                  @click="deleteLimitation()"
                  >حذف محدودیت</v-btn
                >
                <v-btn
                  v-else
                  class="mx-1"
                  small
                  color="error"
                  @click="limitationEditMode = false"
                >
                  انصراف</v-btn
                >
                <v-btn
                  v-if="!limitationEditMode"
                  class="mx-1"
                  small
                  color="primary"
                  @click="editLimitation()"
                  >ویرایش محدودیت</v-btn
                >

                <v-btn
                  v-else
                  class="mx-1"
                  small
                  color="primary"
                  @click="saveLimitation()"
                >
                  ثبت</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-if="EditTechInfoModal"
        v-model="EditTechInfoModal"
        max-width="900px"
      >
        <v-card class="py-6 mb-5">
          <v-card-text>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <v-spacer></v-spacer>
                  <v-sheet outlined>
                    <v-data-table
                      :headers="editTechInfoHeaders"
                      :items="tableItems"
                      tableClasses="item-table border"
                      hide-default-footer
                      disable-pagination
                      fixed-header
                    >
                      <template v-slot:[`item.requireDateUtc`]="{ item }">
                        {{ jalaliDate(item.requireDateUtc) }}
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-btn
                          icon
                          @click="
                            showTechInfos = true;
                            selectedItem = item;
                          "
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-sheet>
                  <v-spacer></v-spacer>
                </v-col>
                <v-col cols="12">
                  <v-sheet v-if="showTechInfos">
                    <v-card class="pa-5">
                      <v-col cols="12" v-if="!selectedItem.technicalHelpNeeded">
                        <trade-request-direct-information-tree-select
                          :techInfos="selectedItem.techInfos"
                          :setTechInfo="true"
                          @getCategoriesList="getCategoriesList"
                          @getTradeRequestItemPropertyValues="
                            getTradeRequestItemPropertyValues
                          "
                        >
                        </trade-request-direct-information-tree-select>
                      </v-col>
                      <v-card-text v-else>
                        برای این قلم کالا نیاز به کمک فنی ثبت شده است
                      </v-card-text>
                    </v-card>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              v-if="selectedTrade.category != 'Product'"
              @click="submitTechInfo"
            >
              ثبت
            </v-btn>
            <v-btn
              @click="
                EditTechInfoModal = false;
                selectedItem = null;
                showTechInfos = false;
              "
              color="error"
            >
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-if="dateExtensionModal"
        v-model="dateExtensionModal"
        max-width="900px"
      >
        <v-card class="py-6 mb-5">
          <v-card-title>
            تمدید سفارش شماره {{ selectedItem.tradeNumber }}
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <label for="">
                  امکان تمدید برای سفارش هایی که کمتر از ۷ روز از تاریخ انقضاء
                  آنها گذشته و تعداد پاسخشان کمتر از سه مورد امکان پذیر می‌باشد.
                </label>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="روز"
                  v-model="dateExtension"
                  outlined
                  dense
                  type="number"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              :disabled="
                dateExtension <= 0 ||
                dateExtension == null ||
                dateExtension == ''
              "
              @click="submitDateExtension"
            >
              ثبت
            </v-btn>
            <v-btn
              @click="
                dateExtensionModal = false;
                selectedItem = null;
                dateExtension = null;
              "
              color="error"
            >
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="text-center pt-5">
        <v-row>
          <v-col cols="12" sm="2" md="2">
            <v-select
              outlined
              dense
              v-model="itemsPerPage"
              :items="[5, 10, 20]"
              label="تعداد نمایش در صفحه"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="10" md="10">
            <v-pagination
              circle
              v-model="pageNumber"
              :length="pageCount ? pageCount : 1"
              :total-visible="7"
            ></v-pagination>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import { GET_ENUMS } from '../../enums/store/types';
const tradeRequestsRepository = () => RepoFactory.get('tradeRequests');
const enumsRepository = () => RepoFactory.get('enums');
const merchantRepository = () => RepoFactory.get('merchant');
import TradeRequestDirectItems from './TradeRequestDirectItems.vue';
import TradeRequestDirectInformationTreeSelect from './TradeRequestDirectInformationTreeSelect';
import AdvanceFilter from '@/components/core/AdvanceFilter';
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
import TradeRequestDirectReport from './TradeRequestDirectReport.vue';

import qs from 'qs';
export default {
  name: '',
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  components: {
    TradeRequestDirectItems,
    TradeRequestDirectInformationTreeSelect,
    AdvanceFilter,
    TradeRequestDirectReport,
  },
  data() {
    return {
      loading: true,
      selected: [],
      reportData: null,
      dateExtension: null,
      dateExtensionModal: false,
      filterColumn: [],
      savedFilters: [],
      showTechInfos: false,
      selectedItem: [],
      selectedTrade: [],
      lightWeightTechInfo: [],
      tableItems: [],
      selectedLimitation: [],
      stateIds: [],
      stateName: [],
      cityName: [],
      tradeRequestOrigin: [],
      statesList: [],
      citiesList: [],
      limitation: null,
      limitationIds: null,
      limitationEditMode: false,
      EditLimitationModal: false,
      EditTechInfoModal: false,
      tradeEventData: [],
      requestStatusList: [],
      tradeCategoriesList: [],
      tradeRequestTypeList: [],
      headers: [
        {
          value: 'tradeNumber',
          text: 'شماره ',
          sortable: true,
        },

        { text: 'تاریخ سفارش', value: 'createdTimeUtc' },
        {
          value: 'requestStatus',
          text: 'وضعیت درخواست',
          sortable: true,
        },
        // {
        //   value: 'request',
        //   text: 'موضوع سفارش',
        //   sortable: true,
        // },
        // {
        //   value: 'category',
        //   text: 'نوع سفارش',
        //   sortable: true,
        // },
        // {
        //   value: 'itemsCount',
        //   text: 'تعداد اقلام سفارش',
        //   sortable: true,
        // },
        // {
        //   value: 'payment',
        //   text: 'وضیعت تسویه',
        //   sortable: true,
        // },
        {
          value: 'operations',
          text: 'اقدام',
          sortable: true,
        },
      ],
      itemsPerPage: this.$store.getters.directOrderListItemsPerPage? this.$store.getters.directOrderListItemsPerPage: 10,
      pageNumber: this.$store.getters.directOrderListPageNumber? this.$store.getters.directOrderListPageNumber: 1,
      items: [],
      editTechInfoHeaders: [
        this.selectedTrade &&
        this.selectedTrade.request == 'ContractorRecognition'
          ? { sortable: false, width: '0px' }
          : {
              value: 'title',
              text: 'موضوع',
              width: '100px',
            },
        {
          value: 'quantity',
          text: 'تعداد قلم',
          width: '100px',
        },
        {
          value: 'requireDateUtc',
          text: 'تاریخ نیاز',
          width: '100px',
        },
        {
          value: 'actions',
          text: 'ویرایش فرآیند ',
          width: '100px',
        },
      ],
      editTechInfoItems: [],
    };
  },
  computed: {
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    pageCount() {
      if (
        this.$store.getters.tradeRequestDirectCurrentList &&
        this.$store.getters.tradeRequestDirectCurrentList.totalCount &&
        this.itemsPerPage > 0
      ) {
        return Math.ceil(
          this.$store.getters.tradeRequestDirectCurrentList.totalCount /
            this.itemsPerPage
        );
      }
    },
  },
  async created() {
    if (!this.$store.getters.allEnums.length) {
      await this.$store.dispatch(GET_ENUMS);
    }
    // if (
    //   this.$store.getters.tradeRequestPageNumber != null &&
    //   this.$store.getters.tradeRequestItemsPerPage != null
    // ) {
    //   this.pageNumber = this.$store.getters.tradeRequestPageNumber;
    //   this.itemsPerPage = this.$store.getters.tradeRequestItemsPerPage;
    // } else {
    //   this.pageNumber = 1;
    //   this.itemsPerPage = 10;
    // }
    //alert(this.$store.getters.directOrderListPageNumber);
    //alert(this.$store.getters.directOrderListItemsPerPage)
     
    if (this.$store.getters.tradeRequestSelectedItem != null) {
      this.selected = [];
      this.selected.push(this.$store.getters.tradeRequestSelectedItem);
    }
    this.$store.getters.authorize;

    if (this.currentMerchant && this.currentMerchant.length) {

      //console.log("craeted = >  this.getData(this.$store.getters.directOrderListPageNumber?? this.pageNumber,this.$store.getters.directOrderListItemsPerPage ?? this.itemsPerPage);")

      console.log(this.$store.getters.directOrderListPageNumber);
      console.log(this.$store.getters.directOrderListItemsPerPage)
      this.getData(this.$store.getters.directOrderListPageNumber ?? this.pageNumber, this.$store.getters.directOrderListItemsPerPage ?? this.itemsPerPage);
    } else if (this.$store.getters.authorize == 'merchant') {
      const loader = this.$loading.show();
      merchantRepository()
        .getAllMerchantsByCurrentUser(this.$store.getters.merchantBaseUrl)
        .then((res) => {
          this.$store.commit('setCurrentMerchant', res.data.merchantId);
        })
        .catch((error) => Helper.handleErrors(error, this))
        .finally(() => loader.hide());
    }

    this.tradeCategories();
    this.tradeRequestType();
    this.requestStatus();
    this.getClassTypeModel();
    if (localStorage.getItem('tradeRequestFilter')) {
      this.savedFilters = JSON.parse(
        localStorage.getItem('tradeRequestFilter')
      );
    }
  },
  watch: {
    currentMerchant(after) {
      if (
        this.$store.getters.tradeRequestDirectCurrentList == null ||
        this.$store.getters.tradeRequestDirectCurrentList == []
      ) {
        this.getData(this.$store.getters.directOrderListPageNumber?? this.pageNumber,this.$store.getters.directOrderListItemsPerPage ?? this.itemsPerPage);
      } else if (
        this.$store.getters.tradeRequestDirectCurrentList &&
        this.$store.getters.tradeRequestDirectCurrentList.list
      ) {
        this.items = this.$store.getters.tradeRequestDirectCurrentList.list;
      }
    },
    limitation(after, before) {
      if ((after == 'City' || after == 'State') && before == null) {
        this.getStates();
      }
    },
    stateIds() {
      if (this.limitation == 'City' && this.stateIds.length) {
        this.getCitiesByStateIds();
      } else if (this.limitation == 'State' && this.stateIds.length) {
        this.limitationIds = this.stateIds;
      }
      if (this.stateIds == [] || this.stateIds == '' || this.stateIds == null) {
        this.citiesList = [];
        this.limitationIds = null;
      }
    },

    pageNumber(after, before) {
      if (after) {
        this.$store.commit('setDirectOrderListPageNumber', after);
        var itms = this.$store.getters.directOrderListItemsPerPage ?? this.itemsPerPage;
        this.getData(after,itms);
      }
    },
    itemsPerPage(after, before) {
      if (after) {
        this.$store.commit('setDirectOrderListItemsPerPage', after);
       var pn= this.$store.getters.directOrderListPageNumber ?? this.pageNumber;
        this.getData(pn,after);
      }
    },
  },
  methods: {
    getClassTypeModel() {
      enumsRepository()
        .getModel('TradeRequestDto', this.tradeBaseUrl)
        .then((res) => {
          this.filterColumn = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    saveFilter() {
      localStorage.setItem(
        'tradeRequestFilter',
        JSON.stringify(this.$refs.advanceFillterRef.Filters)
      );
    },
    addDaysToDate(item) {
      var myDate = new Date(item.createdTimeUtc);
      myDate.setDate(myDate.getDate() + parseInt(item.bidExpirationTimeInDays));
      var today = new Date();
      return myDate < today;
    },
    tradeCategoryDisplayName(title) {
      if (this.tradeCategoriesList.length) {
        let result = this.tradeCategoriesList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeRequestDisplayName(title) {
      if (this.tradeRequestTypeList.length) {
        let result = this.tradeRequestTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    requestStatusDisplayName(title) {
      if (this.requestStatusList.length) {
        let result = this.requestStatusList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    requestStatus() {
      this.requestStatusList = this.getEnumByTitle('TradeRequestStatus');
    },

    tradeCategories() {
      this.tradeCategoriesList = this.getEnumByTitle('CategoryTypeItems');
    },
    tradeRequestType() {
      this.tradeRequestTypeList = this.getEnumByTitle('TradeRequestType');
    },

    getData(pageNumber,itemsPerPage) {
      let app = this;
//       let pageNumber = this.$store.getters.directOrderListPageNumber
//         ? this.$store.getters.directOrderListPageNumber
//         : this.pageNumber;
//       let itemsPerPage = this.$store.getters.directOrderListItemsPerPage
//         ? this.$store.getters.directOrderListItemsPerPage
//         : this.itemsPerPage;
// console.log("paging data : " + pageNumber + " " + itemsPerPage)
      let params = {
        DirectOrder: true,
        PageNumber: pageNumber,
        ItemsPerPage: itemsPerPage,
        Orders: [
          {
            column: 'createdTimeUtc',
            order: 'Descending',
          },
        ],
      };
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .getDirectTradeRequests(
          app.tradeBaseUrl,
          { merchantId: this.currentMerchant },
          params,
          (params) => {
            return qs.stringify(params, { allowDots: true });
          }
        )
        .then((res) => {
          this.loading = false;
          if (res.data.list != null && res.data.list.length >= 0) {
            this.$store.commit('setTradeRequestCurrentList', res.data);
            this.items = res.data.list;
          } else {
            this.items = [];
            this.$store.commit('setTradeRequestCurrentList', res.data);

            //              setDirectOrderListPageNumber (state, payload){
            //   state.directOrderListPageNumber=payload
            // },
            //   setDirectOrderListItemPerPage (state, payload){
            //   state.directOrderListItemPerPage=payload
          }
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    editItem(item) {
      this.$store.commit('setTradeRequestEditMode', true);
      this.$store.commit('setTradeRequestSelectedItem', item);
      this.selected = [];
      this.$store.commit('setTradeRequestIsEdit', true);
      this.$router.push({ path: `/trade-request-direct-edit/${item.id}` });
    },
    sendChatWithAdmin(item) {
      this.$store.commit('setTradeRequestSelectedItem', item);
      this.selected = [];
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestFormStatus', true);
      this.$store.commit('setTradeRequestShowDetailForm', true);
      this.$store.commit('setTradeRequestSelectedForDisplay', item);
      this.$router.push({
        path: `/trade-request-direct-info/${item.id}?tab=Message`,
      });

      // this.$router.push({ path: `/trade-request-chat-with-admin/${item.id}` });
    },
    displayItem(item) {
      this.$store.commit('setTradeRequestSelectedItem', item);
      this.selected = [];
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestFormStatus', true);
      this.$store.commit('setTradeRequestShowDetailForm', true);
      this.$store.commit('setTradeRequestSelectedForDisplay', item);
      this.$store.commit('setDirectTradeRequestSupplierId', item.supplierId); // this item for conversation need on threadlist component
      this.$router.push({ path: `/trade-request-direct-info/${item.id}` });
    },
    confirmRequest(item) {
      this.selected = [];
      this.selected.push(item);
      let app = this;
      const loader = this.$loading.show();

      tradeRequestsRepository()
        .sendConfirmRequest(item.id, this.tradeBaseUrl)
        .then((res) => {
          app.$dialog.info({
            text: `${
              this.$store.getters.currentMerchantObject.isManufacturer
                ? 'صنعتگر'
                : 'فروشنده'
            } محترم از ثبت مشخصات و قابلیتهای فنی واحد کسب و کار خود با نام ${
              this.$store.getters.currentMerchantObject.name
            } سپاسگزاریم، جهت اطلاع موضوع تا 24 ساعت اینده توسط ادمین فنی سایت، بررسی و در صورت تایید در صفحه اینترنتی ویژه شما در تکصان قابل رویت خواهد بود. `,
            title: ' عملیات موفق',
            persistent: true,
            actions: [
              {
                text: 'بستن',
                color: 'red',
              },
            ],
          });
          this.getData(this.$store.getters.directOrderListPageNumber?? this.pageNumber,this.$store.getters.directOrderListItemsPerPage ?? this.itemsPerPage);
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    tradeEvents(item) {
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .getTradeRequestEvents(item.id, this.tradeBaseUrl)
        .then((res) => {
          this.tradeEventData = res;
          this.eventModal = true;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    openlimitationEditModal(item) {
      this.selected = [];
      this.selected.push(item);
      this.selectedTrade = item;
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .getLimitationById(item.id, this.tradeBaseUrl)
        .then((res) => {
          this.selectedLimitation = res.data;
          this.getTradeLimitation();
          this.EditLimitationModal = true;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    openTechInfoEditModal(item) {
      this.selected = [];
      this.selected.push(item);
      this.selectedTrade = item;

      const loader = this.$loading.show();
      tradeRequestsRepository()
        .getTechInfoById(item.id, this.tradeBaseUrl)
        .then((res) => {
          this.lightWeightTechInfo = res.data;
          this.$store.commit('setTradeRequestSelectedForDisplay', res.data);
          this.tableItems = this.lightWeightTechInfo.items;
          this.EditTechInfoModal = true;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getTradeLimitation() {
      if (this.selectedLimitation.limitation == 'State') {
        this.limitation = 'State';
        this.limit = true;
        this.getStates();
        this.selectedLimitation.limitationsDtos.forEach((x) => {
          this.stateIds.push(x.id);
          this.stateName.push(x.value);
        });
      } else if (this.selectedLimitation.limitation == 'City') {
        this.limitation = 'City';
        this.limitationIds = [];

        this.limit = true;
        this.getStates();
        this.selectedLimitation.limitationsDtos.forEach((x) => {
          this.limitationIds.push(x.id);
          this.cityName.push(x.value);
          this.stateIds.push(x.stateId);
          this.stateName.push(x.stateName);
        });
        this.cityName = Array.from(new Set(this.cityName));
        this.limitationIds = Array.from(new Set(this.limitationIds));
        this.stateIds = Array.from(new Set(this.stateIds));
        this.stateName = Array.from(new Set(this.stateName));
      }
    },
    getStates() {
      merchantRepository()
        .getProvince(this.merchantBaseUrl)
        .then((res) => {
          this.statesList = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    getCitiesByStateIds() {
      let params = {
        stateIds: this.stateIds,
      };
      merchantRepository()
        .getCitiesOfMultipleStatesTree(
          this.merchantBaseUrl,
          params,
          {},
          (params) => {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          }
        )
        .then((res) => {
          this.citiesList = res.data;
        });
    },
    deleteLimitation() {
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .deleteTradeRequestLimitation(this.id, this.tradeBaseUrl)
        .then((res) => {
          this.$dialog.message.success(' محدودیت مکانی با موفقیت حذف شد. ', {
            position: 'top-left',
          });
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    editLimitation() {
      this.limitationEditMode = true;
      this.getLimitationEnum();
      this.limitationIds = this.selectedLimitation.limitationIds;
      this.getTradeLimitation();
    },
    getLimitationEnum() {
      enumsRepository()
        .getEnum('TradeRequestLimitationType', this.tradeBaseUrl)
        .then((res) => {
          this.tradeRequestOrigin = res.data.filter((x) => {
            if (x.title != 'Country') return x;
          });
        })
        .catch((err) => Helper.handleErrors(err, this));
    },
    saveLimitation() {
      const loader = this.$loading.show();
      let body = {
        limitation: this.limitation,
        limitationIds: this.limitationIds,
      };
      tradeRequestsRepository()
        .editTradeRequestLimitation(
          this.selectedTrade.id,
          body,
          this.tradeBaseUrl
        )
        .then((res) => {
          this.$dialog.message.success(' محدودیت مکانی با موفقیت ویرایش شد. ', {
            position: 'top-left',
          });
          this.EditLimitationModal = false;
          this.limitationEditMode = false;
          this.limitationIds = [];
          this.cityName = [];
          this.stateIds = [];
          this.stateName = [];
          // this.getDataById();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    normalizerCityList(content) {
      let object = {
        isDisabled: content.disabled,
        id: content.id,
        label: content.value,
      };
      if (content.cityList && content.cityList.length) {
        object.children = content.cityList;
      } else {
        delete content.cityList;
      }

      return object;
    },
    getTradeRequestItemPropertyValues(properties, categoryId) {
      let app = this;
      let techInfo = {
        tradeRequestItemTechInfoId: null,
        productCategoryId: null,
        processType: null,
        tradeRequestItemPropertyValues: null,
      };
      techInfo.tradeRequestItemTechInfoId =
        app.selectedItem.techInfos[0] && app.selectedItem.techInfos[0].id
          ? app.selectedItem.techInfos[0].id
          : null;
      techInfo.productCategoryId = categoryId[0];
      techInfo.processType = 'MainProcess';
      techInfo.tradeRequestItemPropertyValues = properties;
      this.techInfos = techInfo;

      let body,
        items = [];
      this.lightWeightTechInfo.items.forEach((item) => {
        let tradeRequestItemPropertyValues = [];
        item.techInfos[0].tradeRequestItemPropertyValues.forEach((x) => {
          tradeRequestItemPropertyValues.push({
            categoryPropertyId: x.categoryPropertyId,
            id: x.id,
            measurementUnitId: x.measurementUnitId,
            value: x.value,
          });
        });
        if (item.id != this.selectedItem.id) {
          items.push({
            id: item.id,
            techInfos: [
              {
                tradeRequestItemTechInfoId:
                  item.techInfos[0] && item.techInfos[0].id
                    ? item.techInfos[0].id
                    : null,
                productCategoryId: item.techInfos[0].productCategoryId,
                processType: 'MainProcess',
                tradeRequestItemPropertyValues: tradeRequestItemPropertyValues,
              },
            ],
          });
        } else {
          items.push({
            id: this.selectedItem.id,
            techInfos: [this.techInfos],
          });
        }
      });
      body = {
        items: items,
      };
      this.editTechInfo(body);
    },
    submitTechInfo() {
      let body,
        items = [];
      this.lightWeightTechInfo.items.forEach((item) => {
        if (item.id != this.selectedItem.id) {
          items.push({
            id: item.id,
            techInfos: item.techInfos,
          });
        } else {
          items.push({
            id: this.selectedItem.id,
            techInfos: this.techInfos,
          });
        }
      });
      body = {
        items: items,
      };
      this.editTechInfo(body);
    },
    editTechInfo(techInfo) {
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .editTradeRequestTechInfo(
          this.selectedTrade.id,
          techInfo,
          this.tradeBaseUrl
        )
        .then((res) => {
          this.$dialog.message.success(
            ' فرآیند های منتخب با موفقیت ویرایش شد. ',
            {
              position: 'top-left',
            }
          );
          this.techInfos = null;
          this.EditTechInfoModal = false;
          this.selectedItem = null;
          this.showTechInfos = false;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    getCategoriesList(list) {
      if (this.$store.getters.tradeRequestCategoryType != 'Product') {
        let techInfo = [];
        this.categoriesList = list;
        this.categoriesList.forEach((x) => {
          techInfo.push({
            tradeRequestItemTechInfoId: x.techInfoId
              ? x.techInfoId
              : x.id
              ? x.id
              : null,
            processType:
              x.productionProcessType == 'MainProcess'
                ? 'MainProcess'
                : 'SubProcess',
            productCategoryId: x.productCategoryId
              ? x.productCategoryId
              : x.categoryId
              ? x.categoryId
              : null,
            tradeRequestItemPropertyValues: [],
          });
        });
        this.techInfos = techInfo;
      }
    },
    // displayResponse(item) {
    //   this.$store.commit('setTradeRequestSelectedItem', item);
    //   this.selected = [];
    //   this.$store.commit('setTradeRequestNumber', item.tradeNumber);
    //   this.$store.commit('setTradeRequestDate', item.createdTimeUtc);
    //   this.$store.commit('setTradeRequestCategoryType', item.category);
    //   this.$store.commit('setTradeRequestSelectedForResponse', item);
    //   this.$router.push({
    //     path: `/trade-request-direct-display-response/${item.id}`,
    //   });
    // },
    manageResponse(item) {
      this.$store.commit('setTradeRequestSelectedItem', item);
      this.selected = [];
      this.$store.commit('setTradeRequestSelectedForResponse', item);
      this.$store.commit('setTradeRequestCategoryType', item.category);
      this.$router.push({
        path: `/trade-request-direct-manage-response/${item.id}`,
      });
    },
    openDateExtensionModal(item) {
      this.selected = [];
      this.selected.push(item);
      this.selectedItem = item;
      this.dateExtensionModal = true;
    },
    submitDateExtension() {
      const loader = this.$loading.show();
      tradeRequestsRepository()
        .submitDateExtension(
          this.selectedItem.id,
          {
            extendDays: this.dateExtension,
          },
          this.tradeBaseUrl,
          { merchantId: this.currentMerchant }
        )
        .then((res) => {
          this.$dialog.message.success(' تاریخ سفارش با موفقیت تمدید شد. ', {
            position: 'top-left',
          });
          loader.hide();
          this.dateExtensionModal = false;
          this.selectedItem = null;
          this.dateExtension = null;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    viewReport(item) {
      this.$store.commit('setTradeRequestSelectedItem', item);
      this.selected = [item];
      this.$router.push(`/trade-request-direct-report/${item.id}`);
    },
  },
};
</script>

<style></style>
